import { Box, Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import pallet from '../../../layouts/pallet';
import { DataGrid } from '@mui/x-data-grid';
import { dataGridSx } from '../../common/styled/DataGrid';

const FiltersContainer = styled(Box)`
  display: flex;
  gap: 16px;
  align-items: flex-end;
`;

const FilterColumn = styled(Box)`
  display: flex;
  flex-direction: column;
`;

const StyledTextField = styled(Box)``;

const ActionsContainer = styled(Box)`
  display: flex;
  align-items: flex-end;
  gap: 16px;
  justify-content: flex-end;
  width: 100%;
`;

const RoundedButton = styled(Button)`
  border-radius: 8px !important;
  width: 170px !important;
`;

const StyledStaffAttendanceDataGrid = styled(DataGrid)(() => ({
  ...dataGridSx(pallet),
  '& .MuiDataGrid-virtualScroller': { overflowY: 'auto' }
}));

const Wrapper = styled(Box)`
  padding: 20px;
`;

export {
  FiltersContainer,
  FilterColumn,
  StyledTextField,
  ActionsContainer,
  RoundedButton,
  StyledStaffAttendanceDataGrid,
  Wrapper
};
